import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE } from '../lib/config';

const API = `${API_BASE}`;

const AdjustTimesheet = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [ts, setTs] = useState(null);
  const [baseHours, setBaseHours] = useState('');
  const [otHours, setOtHours] = useState('');
  const [nightHours, setNightHours] = useState('');
  const [transport, setTransport] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  const fetchTs = async () => {
    try {
      // 事業者APIしか一覧がないため、プレビューのみ表示にする
      const pv = await fetch(`${API}/pay/preview?timesheet_id=${encodeURIComponent(id)}`, { headers: { Authorization: `Bearer ${token}` } });
      if (pv.ok) {
        const p = await pv.json();
        setTs({ id, preview: p });
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => { fetchTs(); }, [id]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const body = {
        base_hours: baseHours === '' ? undefined : parseFloat(baseHours),
        overtime_hours: otHours === '' ? undefined : parseFloat(otHours),
        night_hours: nightHours === '' ? undefined : parseFloat(nightHours),
        transport: transport === '' ? undefined : parseFloat(transport),
        note,
      };
      const resp = await fetch(`${API}/timesheets/${encodeURIComponent(id)}/adjustments`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      if (!resp.ok) throw new Error('failed');
      alert('差異申請を送信しました');
      navigate('/work/history');
    } catch (e) {
      console.error(e);
      alert('送信に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">差異申請</h1>
      {ts && ts.preview && (
        <div className="mb-4 text-sm text-gray-700">
          <div>合計（現在の見積）: <span className="font-semibold">¥{ts.preview.total}</span></div>
          <div>通常 {ts.preview.base_hours}h / 残業 {ts.preview.overtime_hours}h / 深夜 {ts.preview.night_hours}h / 交通費 ¥{ts.preview.transport}</div>
        </div>
      )}
      <form onSubmit={submit} className="space-y-3">
        <div>
          <label className="block text-sm text-gray-600">通常時間（h）</label>
          <input type="number" step="0.01" value={baseHours} onChange={e=>setBaseHours(e.target.value)} className="w-full border rounded px-3 py-2" placeholder="例: 7.75" />
        </div>
        <div>
          <label className="block text-sm text-gray-600">残業時間（h）</label>
          <input type="number" step="0.01" value={otHours} onChange={e=>setOtHours(e.target.value)} className="w-full border rounded px-3 py-2" />
        </div>
        <div>
          <label className="block text-sm text-gray-600">深夜時間（h）</label>
          <input type="number" step="0.01" value={nightHours} onChange={e=>setNightHours(e.target.value)} className="w-full border rounded px-3 py-2" />
        </div>
        <div>
          <label className="block text-sm text-gray-600">交通費（円）</label>
          <input type="number" step="1" value={transport} onChange={e=>setTransport(e.target.value)} className="w-full border rounded px-3 py-2" />
        </div>
        <div>
          <label className="block text-sm text-gray-600">メモ</label>
          <textarea value={note} onChange={e=>setNote(e.target.value)} className="w-full border rounded px-3 py-2" rows={3} />
        </div>
        <div className="flex gap-2">
          <button type="submit" disabled={loading} className={`px-4 py-2 rounded text-white ${loading?'bg-gray-400':'bg-blue-600 hover:bg-blue-700'}`}>送信</button>
          <button type="button" className="px-4 py-2 rounded border" onClick={()=>navigate(-1)}>戻る</button>
        </div>
      </form>
    </div>
  );
};

export default AdjustTimesheet;
